// extracted by mini-css-extract-plugin
module.exports = {"l-section":"_l-section_l-section__AkGrK","l-section-header":"_l-section_l-section-header__dElWa","l-section-title":"_l-section_l-section-title__7i9Ko"};